document.addEventListener('DOMContentLoaded', function() {
  const userTypeButtons = document.querySelectorAll('.user-type-btn');
  const currentPath = window.location.pathname;

  // Définir les URLs des pages
  const pageUrls = {
    'pro': '/pages/professionnels',
    'particulier': '/pages/particuliers'
  };

  userTypeButtons.forEach(function(button) {
    button.addEventListener('click', function(e) {
      e.preventDefault();

      // Récupérer le type d'utilisateur
      const userType = this.getAttribute('data-user-type');

      // Sauvegarder dans localStorage
      localStorage.setItem('userType', userType);

      // Rediriger vers la page correspondante
      const targetUrl = pageUrls[userType];
      if (targetUrl && currentPath !== targetUrl) {
        window.location.href = targetUrl;
      }
    });
  });

  // Au chargement de la page, marquer le bon bouton comme actif selon la page actuelle
  userTypeButtons.forEach(function(btn) {
    const userType = btn.getAttribute('data-user-type');
    const targetUrl = pageUrls[userType];

    if (currentPath === targetUrl) {
      btn.classList.add('active');
    } else {
      btn.classList.remove('active');
    }
  });

  // Si aucun bouton n'est actif (pas sur une page spécifique), utiliser localStorage
  const hasActiveButton = Array.from(userTypeButtons).some(btn => btn.classList.contains('active'));
  if (!hasActiveButton) {
    const savedUserType = localStorage.getItem('userType') || 'pro';
    userTypeButtons.forEach(function(btn) {
      if (btn.getAttribute('data-user-type') === savedUserType) {
        btn.classList.add('active');
      }
    });
  }
});
